export const HITS_PER_PAGE = 25;
export const ICONS_PER_ROW = 5;



// WEBPACK FOOTER //
// ./app/javascript/views/Sets/settings.js